define('base/MbiLazySizes',[
	'jquery',
	'root/Assets/Js/MbiConfig'
], function(
	$,
	mbiConfig
) {
	'use strict';

	// ----------------------------------------------------------------
	// LAZY SIZES CONFIG
	// ----------------------------------------------------------------

	window.lazySizesConfig = window.lazySizesConfig || {};

	window.lazySizesConfig.lazyClass = 			mbiConfig.lazysizes.lazyClass;
	window.lazySizesConfig.loadingClass = 		mbiConfig.lazysizes.loadingClass;
	window.lazySizesConfig.loadedClass = 		mbiConfig.lazysizes.loadedClass;
	window.lazySizesConfig.autosizesClass = 	mbiConfig.lazysizes.autosizesClass;
	window.lazySizesConfig.errorClass = 		mbiConfig.lazysizes.errorClass;
	window.lazySizesConfig.preloadClass = 		mbiConfig.lazysizes.preloadClass;

	require(['root/Base/Js/Vendor/LazySizes'], function() {

	});

});
